import { Dialog } from './dialog.js';

/**
 * Report dialog.
 */
class ReportDialog extends Dialog {
  static titleMarkup = `Report issue`;

  static bodyMarkup = `
    <form class='default'>
      <label>
        <span>Please describe what's wrong with
          <span class='report-dialog-details'></span>
        </span>
        <textarea rows='5' required></textarea>
      </label>
    </form>
  `;

  static buttons = {
    accept: {
      label: 'Report',
    },
    cancel: {
      label: 'Cancel',
      default: true,
    },
  };

  static get selectors() {
    const baseSelectors = super.selectors;
    const { Body } = baseSelectors;
    return Object.assign({}, baseSelectors, {
      Details: `${Body} .report-dialog-details`,
      Form: `${Body} form`,
      Textarea: `${Body} textarea`,
    });
  }

  static get elements() {
    let s = this.selectors;
    return {
      detailsElement: s.Details,
      form: s.Form,
      textarea: s.Textarea,
    };
  }

  set({ detailsData, detailsMarkup }) {
    this.#data = detailsData;
    this.detailsElement.innerHTML = detailsMarkup;
  }

  show() {
    super.show();
    this.textarea.focus();
  }

  checkValidity() {
    return this.form.reportValidity();
  }

  get data() {
    return {
      data: this.#data,
      message: this.textarea.value,
    };
  }

  static tagName = 'report-dialog';

  #data;
}

ReportDialog.defineCustomElement();

export { ReportDialog };
